var React = require('react');

function HomepageBg (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9940,4543.9c186.244,70.285,166.844,171.639,284.572,294.637s293.341,119.271,393.271,264.329,298.315,174.317,346.419,137.74c.027-22.144-.307-982.611-.307-982.611H9732S9753.756,4473.62,9940,4543.9Z","transform":"translate(-9732 -4257.999)","fill":"#ffcc40"}));
}

HomepageBg.defaultProps = {"width":"1232.264","height":"996.922","viewBox":"0 0 1232.264 996.922"};

module.exports = HomepageBg;

HomepageBg.default = HomepageBg;
